export default {
  "b2b.app-footer.phone": "telefon",
  "b2b.app-footer.ic": "IČ",
  "b2b.app-footer.registration":
    "Zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl B, vložka 10025",
  "b2b.app-footer.rights": "Všechna práva vyhrazena.",
  "b2b.app-footer.cookiesPrinciples": "ZÁSADY POUŽÍVÁNÍ SOUBORŮ COOKIES",
  "b2b.app-footer.cookiesSettings": "NASTAVENÍ COOKIES",
  "b2b.app-footer.privacy": "ZÁSADY OCHRANY OSOBNÍCH ÚDAJÚ"
};
